// Las rutas del modo Videos cortos (ADR-2026-10-30-videos-cortos-con-el-agente).
export const RUTA_VIDEOS_CORTOS = '/videos-cortos';
export const rutaDeSesionDeVideos = (id: string): string => `${RUTA_VIDEOS_CORTOS}/${id}`;
